<script lang="ts" context="module">
  let currentAnalysis: NodeJS.Timeout | null = null;

  export function stopDraftAnalysis() {
    if (currentAnalysis) clearTimeout(currentAnalysis);
    currentAnalysis = null;
  }
</script>

<script lang="ts">
  import {draftStore, menu, preview, project, step} from '../../store';
  import editorStore from '../../lib/editor/editor.store';
  import {onDestroy} from 'svelte';
  import {MENU, STEP} from '@/types/common';
  import {draftName} from '@/store/drafts';
  import editorInstance from '@/lib/editor/editor';

  let previousProjectState: string | null = null;
  let previousPreviewState: string | null = null;

  function analyzeDraftChanges() {
    console.log('Analyzing Draft Changes');
    if (currentAnalysis) clearTimeout(currentAnalysis);
    if ($menu !== MENU.CLIPS) return;
    currentAnalysis = setTimeout(() => {
      if ($step === STEP.CHOOSE_VIDEO || !$project.video) return;
      if ($step === STEP.CHOOSE_TEMPLATE) return;
      if (editorInstance?.history) {
        editorInstance.history.updateNode();
      }
      let _project = JSON.parse(JSON.stringify($project));
      let _preview = JSON.parse(JSON.stringify($preview));
      if (!_project.video) return;
      try {
        delete _project.transcription;
        delete _project.video?.transcription;
      } catch (err) {
        console.warn('Could not delete transcriptions from index');
      }

      // Check if there are actual changes before updating
      const currentProjectState = JSON.stringify(_project);
      const currentPreviewState = JSON.stringify(_preview);

      if (currentProjectState !== previousProjectState || currentPreviewState !== previousPreviewState) {
        console.log('Changes detected, updating draft');
        draftStore.updateDraft(_project, $draftName, _preview);
        previousProjectState = currentProjectState;
        previousPreviewState = currentPreviewState;
      } else {
        console.log('No changes detected, skipping draft update');
      }

      currentAnalysis = null;
    }, 10000); // Debounce
  }

  const unsubscribeProject = project.subscribe(p => {
    analyzeDraftChanges();
  });

  const unsubscribeEditor = editorStore.subscribe(() => {
    analyzeDraftChanges();
  });

  const unsubscribeSteps = step.subscribe(step => {
    analyzeDraftChanges();
  });

  const unsubscribePreview = preview.subscribe(() => {
    analyzeDraftChanges();
  });

  const unsubscribeDraftName = draftName.subscribe(name => {
    analyzeDraftChanges();
  });

  onDestroy(() => {
    unsubscribeProject();
    unsubscribeEditor();
    unsubscribeSteps();
    unsubscribePreview();
    unsubscribeDraftName();
    if (currentAnalysis) clearTimeout(currentAnalysis);
  });
</script>
